import { diInject } from '@di/di';
export class AnimatedCreativeAdApi {
    constructor(options) {
        this._renderer = diInject(3 /* Token.RENDERER */);
        this._animator = diInject(5 /* Token.ANIMATOR */);
        this._feedStore = diInject(6 /* Token.FEED_STORE */, { optional: true });
        console.debug('[AnimatedCreativeAdApi] constructed');
        this._animatedCreative = options.animatedCreative;
        this._creativeDataNode = options.creativeDataNode;
        this._creativeData = options.creativeData;
    }
    play() {
        this._animator.play();
    }
    pause() {
        this._animator.pause();
    }
    stop() {
        this._animator.stop();
    }
    seek(time) {
        if (time === 'preload-frame') {
            time = this._creativeDataNode.getFirstPreloadImageFrame();
        }
        this._animator.seek(time);
    }
    seekAsync(time) {
        if (time === 'preload-frame') {
            time = this._creativeDataNode.getFirstPreloadImageFrame();
        }
        this._animator.seek(time);
        return Promise.all([...this._renderer.preloadingElements.values()]).then(() => undefined);
    }
    mute(muted) {
        this._renderer.mute(muted);
    }
    overrideVideoUrls(videoUrls) {
        const successfulCount = this._renderer.overrideVideoUrls(videoUrls);
        return successfulCount;
    }
    renderDynamicProperties(dynamicData) {
        return this._animatedCreative.updateDynamicPropertyElements_m(dynamicData);
    }
    getAnimator() {
        return this._animator;
    }
    getFeedStore() {
        return this._feedStore;
    }
    getCreativeData() {
        return this._creativeData;
    }
    getCreativeDataNode() {
        return this._creativeDataNode;
    }
}
